import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "label-container" }
const _hoisted_2 = { class: "label-container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue'

import { TripFull } from '@/models/trip'

import { TripCheckOut } from '@/models/checkOut'

import { normalizeFalsy } from '@/helpers/strings'
import { normalizeUserName } from '@/helpers/user'

import DescriptionImage from './DescriptionImage.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckOutItem',
  props: {
    trip: {},
    checkOut: {}
  },
  setup(__props: any) {

const props = __props

const isHost = computed(() => props.trip.host_id === props.checkOut.user_id)

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createBlock(_component_el_descriptions, {
    border: "",
    align: "top",
    column: 2,
    direction: "vertical",
    class: "description-container",
    title: `${isHost.value ? 'Host' : 'Renter'} check-out: ${_ctx.checkOut.id}`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions_item, { width: "50%" }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value ? 'Host' : 'Renter'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeUserName)(isHost.value ? _ctx.trip.host : _ctx.trip.renter)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { width: "50%" }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(`Keys and owneship permit ${isHost.value ? 'are received' : 'are returned'}`), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkOut.keys_returned)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(isHost.value ? 'Renter took belongings' : 'Belongings are taken'), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkOut.no_belongings)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Completed")
        ])),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.checkOut.completed), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { "class-name": "dashboard-container" }, {
        label: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Dashboard ")
        ])),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, " Odometer value: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkOut.odometer_value)), 1),
          _createElementVNode("div", _hoisted_2, " Fuel amount: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkOut.fuel_amount)), 1),
          (_ctx.checkOut.dashboard_image)
            ? (_openBlock(), _createBlock(DescriptionImage, {
                key: 0,
                xl: 6,
                lg: 6,
                md: 8,
                images: [_ctx.checkOut.dashboard_image]
              }, null, 8, ["images"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, " Dashboard photo: " + _toDisplayString(_unref(normalizeFalsy)(_ctx.checkOut.dashboard_image)), 1))
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_descriptions_item, null, null, 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Post-trip pictures of the vehicle ")
        ])),
        default: _withCtx(() => [
          (_ctx.checkOut.vehicle_images && _ctx.checkOut.vehicle_images.length)
            ? (_openBlock(), _createBlock(DescriptionImage, {
                key: 0,
                images: _ctx.checkOut.vehicle_images.map(item => item.secure_url)
              }, null, 8, ["images"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, " not set "))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})